export const pageContent = {
  slideX: {
    slideContent:
      "The text content for the given slide, usually a paragraph or two. In the intro slide, this content represents the DEK. If the text includes more than one paragraph, just write {newParagraph} in between to split it up. Do not separate the paragraphs with line breaks.",
    photoFileName:
      "The file name of the photo that goes with the content above. The name needs to match exactly and include the suffix at the end (for example: “060223_fort_greene_interrupters_crop_1.jpg”) If left blank, the content will show up on a blank screen. (OPTIONAL)",
    photoPosition:
      "For engineers to fill out. This specifies what part of the photo should be centered on mobile. (OPTIONAL)",
  },
  slide0: {
    slideContent:
      "“I see more strollers now than briefcases,” said Harish Kamath while walking his 4-year-old son Raey to school just after dawn. Kamath and family moved into the area in 2019.",
    photoFileName: "091523_fidi_1.jpg",
    photoPosition: "40%",
  },
  slide1: {
    slideContent:
      "The neighborhood covering the southern tip of Manhattan below the Brooklyn Bridge and Battery Park City has seen a large influx of residents under 35.",
    photoFileName: "map.png",
    photoPosition: "",
  },
  slide2: { slideContent: "", photoFileName: "", photoPosition: "" },
  slide3: {
    slideContent:
      "Construction worker Eric Lawson gets his early-morning coffee and breakfast sandwich before heading to his job at a residential site under development.",
    photoFileName: "091523_fidi_2.jpg",
    photoPosition: "",
  },
  slide4: {
    slideContent:
      "Debi Lee, who was first drawn to FiDi by the affordable rents after 9/11, said she loved the open spaces and free concerts at the Seaport. Here she’s seen walking her dog, Presley, early in the morning along the East River.",
    photoFileName: "091523_fidi_5.jpg",
    photoPosition: "",
  },
  slide5: {
    slideContent:
      "Molloy University musical theater majors Jaz Koft, right, and Zelia Gourdon grab a coffee before heading to class in FiDi. The school opened a FiDi campus in 2018.",
    photoFileName: "091523_fidi_6.jpg",
    photoPosition: "80%",
  },
  slide6: {
    slideContent:
      "Tourists photograph themselves and each other at the Charging Bull sculpture near Bowling Green.",
    photoFileName: "091523_fidi_3.jpg",
    photoPosition: "25%",
  },
  slide7: {
    slideContent:
      "Bean & Bean owner and longtime FiDi resident Jiyoon Han visits workers at the Broadway cafe on a Friday morning.",
    photoFileName: "091523_fidi_7.jpg",
    photoPosition: "",
  },
  slide8: {
    slideContent:
      "Fundraising consultant Lucas Hunt, left, and his wife, landscape architect Annie Phaosawasdi, moved to Gold Street in FiDi during the pandemic while looking for more space after they got married.",
    photoFileName: "091523_fidi_8.jpg",
    photoPosition: "62%",
  },
  slide9: {
    slideContent:
      "FiDi has also seen an increase in tourism as hotels have popped up around the neighborhood.",
    photoFileName: "091523_fidi_9.jpg",
    photoPosition: "25%",
  },
  slide10: {
    slideContent:
      "Tourists, workers and locals grab food at a market near the rebuilt World Trade Center.",
    photoFileName: "091523_fidi_10.jpg",
    photoPosition: "",
  },
  slide11: {
    slideContent:
      "“I love how we’re so close to the water,” said Camille Molas, 24, who works from home in the apartment she shares with her fiancé on Gold Street. “Even though you have big buildings you kind of feel like you’re in a different part of New York.”",
    photoFileName: "091523_fidi_12.jpg",
    photoPosition: "70%",
  },
  slide12: {
    slideContent:
      "Chandeliers hung in the lobby of 95 Water Street, one of several buildings in the area converted from office space to residential.",
    photoFileName: "091523_fidi_13.jpg",
    photoPosition: "",
  },
  slide13: {
    slideContent:
      "Despite its evolution to a residential hot spot, FiDi still retains a sizable workforce of office professionals.",
    photoFileName: "091523_fidi_23.jpg",
    photoPosition: "60%",
  },
  slide14: {
    slideContent:
      "FiDi’s skyline still looms large for tourists and commuters on the Staten Island Ferry.",
    photoFileName: "091523_fidi_14.jpg",
    photoPosition: "23%",
  },
};
